import React from 'react';
import classes from './LogoutAdItem.module.css';
import strings from '../../../assets/localization';

const LogoutAdItem = (props) => {
  return (
    <div className={classes.ListItem} onClick={props.onAdClick}>
      <div className={classes.ListItemLeft}>
        <div className={classes.ListItemImageWrapper}>
          <div
            className={classes.ListItemImage}
            style={{ backgroundImage: `url(${props.ad.image})` }}
          />
        </div>
      </div>
      <div className={classes.ListItemRight}>
        <div className={classes.ListItemRightData}>
          <span>
            <div className={classes.ListItemText}>{props.ad.title}</div>
          </span>
          <span className={classes.ListItemS}>{strings.sponsored}</span>
        </div>
        <svg className={classes.ListItemRightArrow}>
          <use xlinkHref='/sprites.svg#icon-arrow-right' />
        </svg>
      </div>
    </div>
  );
};

export default LogoutAdItem;



// WEBPACK FOOTER //
// ./src/components/Logout/LogoutAdItem/LogoutAdItem.js